import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';

const aboutFeatures = [
  {
    icon: 'ri-timer-flash-line',
    title: '7×24 不打烊',
    description: '全天候实时追踪娱乐圈最新动态，夜间也有值班编辑更新，不错过任何一个猛料。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '独家爆料验证',
    description: '每条爆料都经过多重交叉验证，确保信息真实可靠，杜绝虚假谣言传播。',
  },
  {
    icon: 'ri-global-line',
    title: '全网热点聚合',
    description: '聚合微博、抖音、小红书等全网平台的热点内容，一站式吃瓜不迷路。',
  },
  {
    icon: 'ri-lock-line',
    title: '隐私安全保护',
    description: '匿名投稿机制严格保护爆料人隐私，采用端到端加密技术确保信息安全。',
  },
];

export default function AboutPage() {
  return (
    <>
      <title>关于我们 - 51黑料吃瓜网 | 品牌介绍与联系方式</title>
      <meta name="description" content="51黑料吃瓜网品牌介绍，了解我们的发展历程、核心优势与公信力评价。7×24小时不打烊，全网最热娱乐爆料内容平台。联系我们进行爆料投稿与合作。" />
      <meta name="keywords" content="51黑料,关于我们,品牌介绍,黑料爆料,吃瓜网,联系方式,爆料投稿" />
      <link rel="canonical" href="https://51heiliao.com/about" />
      <meta property="og:title" content="关于我们 - 51黑料吃瓜网" />
      <meta property="og:description" content="51黑料吃瓜网品牌介绍，了解我们的发展历程、核心优势与公信力评价。7×24小时不打烊娱乐爆料平台。" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://51heiliao.com/about" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="关于我们 - 51黑料吃瓜网" />
      <meta name="twitter:description" content="51黑料吃瓜网品牌介绍，了解我们的发展历程、核心优势与公信力评价。" />

      <SchemaOrg
        type="WebPage"
        data={{
          name: '关于我们 - 51黑料吃瓜网',
          url: 'https://51heiliao.com/about',
          description: '51黑料吃瓜网品牌介绍，了解我们的发展历程与核心优势',
          isPartOf: {
            '@type': 'WebSite',
            name: '51黑料吃瓜网',
            url: 'https://51heiliao.com/',
          },
        }}
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: '51黑料吃瓜网',
          url: 'https://51heiliao.com/',
          description: '全网最热娱乐爆料内容平台，7×24小时不打烊，汇聚每日黑料大赛独家猛料',
          foundingDate: '2020',
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'customer service',
            email: 'contact@51heiliao.com',
            availableLanguage: ['Chinese'],
          },
          sameAs: [
            'https://weibo.com/51heiliao',
            'https://space.bilibili.com/51heiliao',
          ],
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: '首页',
              item: 'https://51heiliao.com/',
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: '关于我们',
            },
          ],
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: [
            {
              '@type': 'Question',
              name: '51黑料吃瓜网是什么？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '51黑料吃瓜网是一个中文娱乐爆料内容平台，汇聚网红明星最新独家猛料、吃瓜视频、每日黑料大赛等内容，7×24小时不打烊实时追踪。',
              },
            },
            {
              '@type': 'Question',
              name: '如何向51黑料投稿爆料？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '您可以通过我们的匿名投稿系统提交爆料内容。我们采用端到端加密技术，严格保护爆料人隐私。所有投稿都会经过编辑团队的交叉验证后再发布。',
              },
            },
            {
              '@type': 'Question',
              name: '51黑料的爆料内容是否可靠？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '每条爆料都经过我们的独家验证体系进行多重核实，确保信息的真实性和可靠性。我们拒绝传播未经证实的虚假谣言。',
              },
            },
            {
              '@type': 'Question',
              name: '51黑料有哪些内容分类？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '我们拥有五大核心分类频道：明星八卦、网红爆料、综艺内幕、影视黑料和音乐圈，覆盖娱乐圈各个领域的最新动态。',
              },
            },
          ],
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <section className="relative w-full h-[420px] md:h-[500px] flex items-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20warm%20elegant%20brand%20story%20backdrop%20with%20soft%20amber%20and%20deep%20coral%20gradient%2C%20cinematic%20depth%20of%20field%2C%20luxurious%20golden%20texture%2C%20editorial%20quality%2C%20rich%20atmospheric%20warmth%2C%20professional%20and%20trustworthy%20vibe%2C%20elegant%20bokeh%20highlights%2C%20dramatic%20composition&width=1800&height=1200&seq=about-hero&orientation=landscape"
            alt="关于51黑料吃瓜网"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>
          <div className="relative z-10 w-full px-4 md:px-6">
            <div className="max-w-[1400px] mx-auto">
              <div className="max-w-2xl">
                <span className="inline-block px-4 py-1.5 rounded-full border border-white/40 text-white/90 text-xs md:text-sm font-medium mb-4 whitespace-nowrap">
                  <i className="ri-information-line mr-1.5"></i>
                  关于我们
                </span>
                <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-3">
                  了解51黑料吃瓜网
                </h1>
                <p className="text-white/70 text-sm md:text-base max-w-lg leading-relaxed">
                  全网最热的娱乐爆料内容平台，用专业和诚信为每一位吃瓜群众保驾护航
                </p>
              </div>
            </div>
          </div>
        </section>

        <main>
          <Breadcrumb items={[{ label: '关于我们' }]} />

          <section className="w-full py-12 md:py-18 bg-background-50">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6">
              <div className="text-center mb-10">
                <span className="text-xs text-foreground-400 font-heading italic">品牌故事</span>
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mt-2 leading-tight">
                  从一个小小
                  <span className="font-heading italic font-bold text-primary-500 mx-1">吃瓜群</span>
                  到全网最大爆料平台
                </h2>
                <p className="text-foreground-500 text-sm max-w-2xl mx-auto mt-3 leading-relaxed">
                  51黑料吃瓜网成立于2020年，由一群热爱娱乐八卦的资深媒体人创立
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
                <div className="bg-primary-100/80 rounded-xl p-6 md:p-8 relative overflow-hidden">
                  <span className="absolute top-5 right-5 w-10 h-10 rounded-full bg-white/30 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-primary-600"></i>
                  </span>
                  <div className="text-4xl md:text-5xl font-heading font-bold text-primary-700 mb-2">5000+</div>
                  <p className="text-sm text-foreground-700 font-medium mb-1">独家爆料内容</p>
                  <p className="text-xs text-foreground-500 leading-relaxed">平台累计发布超过5000条独家爆料内容，涵盖娱乐圈各大领域</p>
                  <p className="text-xs text-foreground-400 italic mt-3">—— 每一篇爆料，都经得起检验</p>
                </div>
                <div className="bg-accent-100/80 rounded-xl p-6 md:p-8 relative overflow-hidden">
                  <span className="absolute top-5 right-5 w-10 h-10 rounded-full bg-white/30 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-accent-600"></i>
                  </span>
                  <div className="text-4xl md:text-5xl font-heading font-bold text-accent-700 mb-2">2000万+</div>
                  <p className="text-sm text-foreground-700 font-medium mb-1">月活跃用户</p>
                  <p className="text-xs text-foreground-500 leading-relaxed">每月超过2000万用户在51黑料吃瓜网上获取最新娱乐爆料资讯，日均浏览量突破百万</p>
                  <p className="text-xs text-foreground-400 italic mt-3">—— 吃瓜群众的共同选择</p>
                </div>
              </div>
            </div>
          </section>

          <section className="w-full py-12 md:py-18 bg-background-100">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6">
              <div className="text-center mb-10 md:mb-12">
                <span className="inline-block px-4 py-1.5 rounded-full border border-background-300 text-foreground-600 text-xs font-medium mb-3 whitespace-nowrap">
                  核心优势
                </span>
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-2">
                  为什么千万用户选择51黑料
                </h2>
                <p className="text-foreground-500 text-sm">我们的核心竞争力，成就行业领先地位</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
                {aboutFeatures.map((feature, index) => (
                  <div
                    key={index}
                    className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:bg-primary-500 hover:border-primary-500 transition-all duration-300 cursor-pointer"
                  >
                    <div className="w-11 h-11 rounded-lg bg-secondary-100 flex items-center justify-center mb-4 group-hover:bg-white/20 transition-colors">
                      <i className={`${feature.icon} text-xl text-secondary-600 group-hover:text-white transition-colors`}></i>
                    </div>
                    <h3 className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-white mb-2 transition-colors whitespace-nowrap">
                      {feature.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500 group-hover:text-white/80 leading-relaxed mb-3 transition-colors">
                      {feature.description}
                    </p>
                    <span className="inline-flex items-center gap-1 text-xs font-medium text-foreground-400 group-hover:text-white/70 transition-colors whitespace-nowrap">
                      了解更多
                      <i className="ri-arrow-right-line text-xs"></i>
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="w-full py-12 md:py-18 bg-background-50">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6">
              <div className="text-center mb-10">
                <div className="inline-flex items-center gap-2 mb-2">
                  <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                  <span className="text-xs font-medium text-accent-700 whitespace-nowrap">媒体与用户口碑</span>
                </div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
                  公信力评价
                </h2>
                <p className="text-foreground-500 text-sm">听听媒体和用户对51黑料的真实评价</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-[1100px] mx-auto">
                {[
                  {
                    user: '新娱乐周刊',
                    role: '行业媒体',
                    text: '51黑料吃瓜网凭借其严谨的验证体系和快速的更新节奏，已经成为娱乐爆料领域的标杆平台。其独家内容的准确率在同行中遥遥领先。',
                  },
                  {
                    user: '媒体观察报',
                    role: '独立媒体',
                    text: '在信息爆炸的时代，51黑料做到了快而不乱、多而不滥。每条爆料都经过事实核查，这在娱乐内容平台中实属难得。',
                  },
                  {
                    user: '资深用户老张',
                    role: '5年忠实用户',
                    text: '从平台刚上线就一直在用了，见证了51黑料的成长。现在每天不刷一遍就感觉少了点什么，真心推荐给所有吃瓜爱好者！',
                  },
                ].map((item, i) => (
                  <div key={i} className="bg-background-100 rounded-xl p-5 border border-background-200/70">
                    <div className="flex gap-0.5 mb-2">
                      {[1, 2, 3, 4, 5].map((_, j) => (
                        <span key={j} className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-star-fill text-accent-500 text-xs"></i>
                        </span>
                      ))}
                    </div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-2">值得信赖的吃瓜平台</h4>
                    <p className="text-xs text-foreground-500 leading-relaxed mb-4">{item.text}</p>
                    <div className="flex items-center gap-2 pt-3 border-t border-background-200">
                      <div className="w-7 h-7 rounded-full bg-primary-100 flex items-center justify-center">
                        <span className="text-xs font-bold text-primary-600">{item.user.charAt(0)}</span>
                      </div>
                      <div>
                        <p className="text-xs font-semibold text-foreground-800">{item.user}</p>
                        <p className="text-xs text-foreground-400">{item.role}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="relative w-full h-[450px] md:h-[520px] flex items-center justify-center overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20warm%20dramatic%20investigative%20journalism%20backdrop%2C%20soft%20amber%20and%20deep%20coral%20gradient%2C%20cinematic%20lighting%2C%20mysterious%20and%20trustworthy%20atmosphere%2C%20editorial%20magazine%20quality%2C%20rich%20textures%2C%20elegant%20bokeh%2C%20professional%20composition&width=1800&height=1200&seq=cta-tips&orientation=landscape"
              alt="爆料投稿"
              className="absolute inset-0 w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
            <div className="relative z-10 text-center px-4 max-w-2xl mx-auto">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-white mb-3 tracking-wide">
                有料要爆？
              </h2>
              <p className="text-white/70 text-sm md:text-base mb-8 leading-relaxed">
                安全匿名投稿，24小时不打烊审核
                <br />
                你的爆料可能成为明天的头条新闻
              </p>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-foreground-950 text-white hover:bg-foreground-900 font-semibold text-sm md:text-base transition-all duration-300 whitespace-nowrap"
              >
                <span className="w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center">
                  <i className="ri-send-plane-line text-white text-xs"></i>
                </span>
                立即匿名投稿
                <i className="ri-arrow-right-up-line ml-1"></i>
              </Link>
            </div>
          </section>

          <section className="w-full py-12 md:py-18 bg-background-50">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto">
                <div className="text-center mb-8">
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">联系我们</h2>
                  <p className="text-foreground-500 text-sm">有任何问题或合作意向，欢迎随时联系</p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                  <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/70">
                    <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                      <i className="ri-mail-line text-xl text-primary-600"></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">电子邮箱</h3>
                    <p className="text-xs text-foreground-500">contact@51heiliao.com</p>
                  </div>
                  <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/70">
                    <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                      <i className="ri-wechat-line text-xl text-primary-600"></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">微信公众号</h3>
                    <p className="text-xs text-foreground-500">搜索「51黑料吃瓜网」</p>
                  </div>
                  <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/70">
                    <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                      <i className="ri-weibo-line text-xl text-primary-600"></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">官方微博</h3>
                    <p className="text-xs text-foreground-500">@51黑料吃瓜网官微</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}